import { Wizard } from "src/app/core/wizard/wizard";
import { OnDestroy, Injectable } from "@angular/core";
import { RankDetailWizardComponent } from "./rank-detail-wizard/rank-detail-wizard.component";

// new-popup-wizard.ts
@Injectable({
  providedIn: 'root'
})
export class RankByStoreWizard extends Wizard<any> implements OnDestroy {
  key = 'ranking-detail';
  pageTypeMap = {
    'ranking-detail': RankDetailWizardComponent,
  };

  startingPageKey = 'ranking-detail';
  hideFooter = true;
  width = 720;
  // height = '92vh';
  maxHeight = 'none';

  constructor() {
    super();

    // Add resize event listener

  }

  // Don't forget to clean up the event listener when the component is destroyed
  ngOnDestroy() {

  }


}
